import "moment-timezone";
import "common/services/services";
import "common/intercom/intercomModule";

export default function ImportPackagesCtrl(
    $sbExternalService,
    $sbCurrentProject,
    $state,
    $window,
    SABLONO_STATES
) {
    "ngInject";
    /////////////////////
    //
    //      Direct variables
    //
    /////////////////////

    init();

    async function init() {
        const projectId = $sbCurrentProject.pick("id");

        const importPackageModalData = {
            projectId,
            navigateToImportSelection,
            navigateToTracker,
        };

        $sbExternalService.openImportPackageModal(importPackageModalData);
    }

    function navigateToImportSelection() {
        $window.history.back();
    }

    function navigateToTracker(params) {
        $state.go(SABLONO_STATES.tracker, params);
    }
}
